import { Box, Flex, Text, Image, Grid, GridItem, Tabs, TabList, Tab, TabPanels, TabPanel } from "@chakra-ui/react";
import MyDiv from "./attendanceSheet.style";
import EmployeeIcon from "../../../assets/images/TotalEmployeeIcon.svg";
import PresenceIcon from "../../../assets/images/PersenceIcon.svg";
import AbsenceIcon from "../../../assets/images/AbsenceIcon.svg";
import LateIcon from "../../../assets/images/LateIcon.svg";
import { CustomToast } from "../../../components";
import { useFetch } from "../../../hooks/useFetch";
import { AttendanceList } from "../components";
import { useEffect, useState } from "react";
import { Attendance } from "./modal";
import { IFilterOptions } from '../../../components/FilterCard/filterCard';
import { useLocation } from "react-router";
import EmployeeWiseAttendanceList, { EmployeeSummary } from "../components/employeeWiseAttendanceList/employeeWiseAttendanceList";

type CardItem = {
  label: string;
  icon: string;
  count: number;
  status?: number[] | null;
};

const EMPTY_SUMMARY: EmployeeSummary = {
  totalDays: 0, present: 0, absent: 0, halfDay: 0, late: 0,
  earlyOut: 0, punchMissing: 0, weekOff: 0, shortLeave: 0, slHalfDay: 0,
};

const AttendanceSheet = () => {
  const location = useLocation();
  const { branchId = 0, branchName = "", selectedDate: navigationDate } = location.state || {};
  const { addToast } = CustomToast();
  const { fetchApi, loading } = useFetch(addToast);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [selectedDate, setSelectedDate] = useState<Date>(() => {
    if (navigationDate) {
      return new Date(navigationDate);
    }
    return new Date();
  });

  const [filterApplied, setFilterApplied] = useState(false);
  const [attendanceFilter, setAttendanceFilter] = useState<{ status?: number[] }>({});

  const [attendanceData, setAttendanceData] = useState<Attendance>({
    totalCount: 0,
    totalEmployees: 0,
    totalPresent: 0,
    totalHalfDay: 0,
    totalPunchMissing: 0,
    totalAbsent: 0,
    totalLateAndEarlyout: 0,
    totalLate: 0,
    totalShortLeave: 0,
    totalSLHalfDay: 0,
    records: []
  });
  const [lazyParams, setLazyParams] = useState({ first: 0, rows: 20, page: 0, sortField: '', sortOrder: 1 });
  const [totalCount, setTotalCount] = useState<number>(0);
  const [selectedItems, setSelectedItems] = useState<Record<string, number[]>>({});


  const [tabIndex, setTabIndex] = useState(0);
  const [employeeSummary, setEmployeeSummary] = useState<EmployeeSummary | null>(null);

  const dateCards: CardItem[] = [
    { label: "Total", icon: EmployeeIcon, count: attendanceData.totalEmployees, status: null },
    { label: "Present", icon: PresenceIcon, count: attendanceData.totalPresent, status: [1] },
    { label: "Absent", icon: AbsenceIcon, count: attendanceData.totalAbsent, status: [0] },
    { label: "Half day", icon: LateIcon, count: attendanceData.totalHalfDay, status: [2] },
    { label: "Late", icon: LateIcon, count: attendanceData.totalLate, status: [3] },
    { label: "Early out", icon: LateIcon, count: attendanceData.totalLateAndEarlyout, status: [4] },
    { label: "Punch missing", icon: LateIcon, count: attendanceData.totalPunchMissing, status: [5] },
    { label: "Short Leave", icon: LateIcon, count: attendanceData.totalShortLeave, status: [9] },
    { label: "SL-Half Day", icon: LateIcon, count: attendanceData.totalSLHalfDay, status: [10] },
  ];

  const s = employeeSummary ?? EMPTY_SUMMARY;

  const employeeCards: CardItem[] = [
    { label: "Total Days", icon: EmployeeIcon, count: s.totalDays },
    { label: "Present", icon: PresenceIcon, count: s.present },
    { label: "Absent", icon: AbsenceIcon, count: s.absent },
    { label: "Half day", icon: LateIcon, count: s.halfDay },
    { label: "Late", icon: LateIcon, count: s.late },
    { label: "Early out", icon: LateIcon, count: s.earlyOut },
    { label: "Punch missing", icon: LateIcon, count: s.punchMissing },
    { label: "Week off", icon: LateIcon, count: s.weekOff },
    { label: "Short Leave", icon: LateIcon, count: s.shortLeave },
    { label: "SL-Half Day", icon: LateIcon, count: s.slHalfDay },
  ];

  const visibleCards: CardItem[] = tabIndex === 0 ? dateCards : employeeCards;

  const pageCount = Math.ceil(totalCount / lazyParams.rows);
  const [filter, setFilter] = useState<IFilterOptions>({ filterOptions: {} });

  const handlePageClick = ({ selected }: { selected: number }) => {
    setLazyParams({
      ...lazyParams,
      page: selected,
      first: selected * lazyParams.rows,
    });
  };

  const setRowsPerPage = (rows: number) => {
    setLazyParams((prev) => ({ ...prev, rows, page: 0, first: 0 }));
  };

  async function loadAttendanceFilter() {
    const response = await fetchApi<IFilterOptions>('Filters/AttendanceFilter', 'GET', null, null, '');
    if (response) {
      setFilter(response);
    }
  }

  const handleAttendanceCardClick = (card: CardItem) => {
    if (!card.status) {
      setSelectedItems(prev => {
        const updated = { ...prev };
        delete updated.Status;
        return updated;
      });
      setAttendanceFilter({});
    } else {
      setAttendanceFilter(prev => {
        if (prev.status && JSON.stringify(prev.status) === JSON.stringify(card.status)) {
          return {};
        }
        return { status: card.status as number[] };
      });
    }

    setLazyParams(prev => ({ ...prev, page: 0, first: 0 }));
  };

  const getFormattedDate = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const loadMaster = async () => {
    try {
      const filtersObj: Record<string, number[]> = {
        ...selectedItems,
        ...(attendanceFilter.status && { Status: attendanceFilter.status })
      };

      const query = new URLSearchParams({
        name: debouncedSearch.trim(),
        date: getFormattedDate(selectedDate),
        lazyParams: JSON.stringify(lazyParams),
        filters: JSON.stringify(filtersObj),
        branchId: String(branchId ?? 0)
      }).toString();

      const response = await fetchApi<Attendance>("Hrlense_Attendance", "GET", null, query);
      if (response) {
        setAttendanceData({
          totalCount: response.totalCount,
          totalEmployees: response.totalEmployees,
          totalPresent: response.totalPresent,
          totalAbsent: response.totalAbsent,
          totalHalfDay: response.totalHalfDay,
          totalLateAndEarlyout: response.totalLateAndEarlyout,
          totalPunchMissing: response.totalPunchMissing,
          totalLate: response.totalLate,
          totalShortLeave: response.totalShortLeave,
          totalSLHalfDay: response.totalSLHalfDay,
          records: response.records,
        });
        setTotalCount(response.totalCount);
      }
    } catch (error) {
      console.error("Failed to fetch attendance:", error);
    }
  };

  useEffect(() => {
    loadMaster();
  }, [debouncedSearch, selectedDate, lazyParams, attendanceFilter]);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearch(searchTerm), 500);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  useEffect(() => {
    loadAttendanceFilter();
  }, []);

  return (
    <MyDiv>
      <Box className="page_wrapper ">
        <Flex className="page_heading flex_header">
          <Text className="font-poppins text_3xl text_semibold">
            Attendance {!filterApplied && branchName ? ` >> ${branchName}` : ""}
          </Text>
        </Flex>

        {/* Cards: Date Wise = whole company for the date, Employee Wise = chosen employee's month */}

        <Grid templateColumns="repeat(auto-fit, minmax(123px, 1fr))" gap={4} mt={4}>
          {visibleCards.map((card, index) => {
            const isActive =
              tabIndex === 0 &&
              !!card.status &&
              attendanceFilter.status?.length === card.status.length &&
              card.status.every((s) => attendanceFilter.status?.includes(s));
            return (
              <GridItem
                key={`${tabIndex}-${card.label}-${index}`}
                className="card_box"
                cursor={tabIndex === 0 ? "pointer" : "default"}
                bg={isActive ? "blue.50" : "white"}
                border={isActive ? "1px solid #3182ce" : "1px solid #e2e8f0"}
                onClick={() => tabIndex === 0 && handleAttendanceCardClick(card)}
              >
                <Flex align="center" gap={3} mb={3}>
                  <Image src={card.icon} className="card_icon" alt={card.label} />
                  <Text className="card_label font-poppins text_md text_medium">{card.label}</Text>
                </Flex>
                <Text className="card_value font-poppins text_bold">{card.count}</Text>
              </GridItem>
            );
          })}
        </Grid>
      </Box>

      <Grid className="grid_container" mt={4}>
        <GridItem colSpan={12}>
          <Tabs
            isLazy
            colorScheme="green"
            index={tabIndex}
            onChange={(i) => {
              setTabIndex(i);
              setEmployeeSummary(null);
            }}
          >
            <TabList>
              <Tab className="font-poppins text_sm text_medium">Date Wise</Tab>
              <Tab className="font-poppins text_sm text_medium">Employee Wise</Tab>
            </TabList>

            <TabPanels>
              <TabPanel px={0}>
                <AttendanceList
                  pageCount={pageCount}
                  attendanceData={attendanceData}
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                  lazyParams={lazyParams}
                  setLazyParams={setLazyParams}
                  totalCount={totalCount}
                  handlePageClick={handlePageClick}
                  loading={loading}
                  setRowsPerPage={setRowsPerPage}
                  filter={filter}
                  setSelectedItems={setSelectedItems}
                  setFilterApplied={setFilterApplied}
                  setAttendanceFilter={setAttendanceFilter}
                />
              </TabPanel>

              <TabPanel px={0}>
                <Text className="font-poppins text_medium text_lg" mb={4}>Attendance Employee List</Text>
                <EmployeeWiseAttendanceList onSummaryChange={setEmployeeSummary} />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </GridItem>
      </Grid>
    </MyDiv>
  );
};

export default AttendanceSheet;